import React, { useState } from 'react';
import styled from 'styled-components/macro';
import {
  Col, Container, Row,
} from '../../components/grid';
import FullWidthLayout from '../../layout/DefaultLayout/Layouts/FullWidthLayout';

const TextareaStyled = styled('textarea')`
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
`;

function SvgDownloader() {
  const [svgCode, setSvgCode] = useState('');
  const [svgContent, setSvgContent] = useState(null);
  const [filename, setFilename] = useState('my-svg');

  const createSvgContent = (code) => {
    const svgRef = React.createRef();
    const onLoad = () => {
      URL.revokeObjectURL(svgRef.current.data);
    };
    const blob = new Blob([code], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    return <object type="image/svg+xml" ref={svgRef} data={url} aria-label="svg-content" onLoad={onLoad} />;
  };

  const handleSvgCodeChange = (event) => {
    let code = event.target.value;
    code = code.replace(/stroke-width=/g, 'stroke-wtemp=');
    code = code.replace(/width="[^"]*"/g, '');
    code = code.replace(/height="[^"]*"/g, 'height="200px"');
    code = code.replace(/stroke-wtemp=/g, 'stroke-width=');
    setSvgCode(code);
    setSvgContent(createSvgContent(code));
  };

  const handleDownload = () => {
    const blob = new Blob([svgCode], { type: 'image/svg+xml' });
    const link = document.createElement('a');
    link.download = `${filename.endsWith('.svg') ? filename : `${filename}.svg`}`;
    link.href = URL.createObjectURL(blob);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFilenameChange = (event) => {
    const { value } = event.target;
    setFilename(value);
  };

  const handleFilenameFocus = (event) => {
    event.target.select();
  };

  return (
    <div>
      Filename: <input id="filename" type="text" value={filename} onChange={handleFilenameChange} onFocus={handleFilenameFocus} />
      <br />
      <br />
      <TextareaStyled
        value={svgCode}
        onChange={handleSvgCodeChange}
        placeholder="Paste SVG code here"
      />
      <button type="submit" onClick={handleDownload}>Download SVG</button>
      <br />
      <br />
      {svgContent}
    </div>
  );
}

export default () => (
  <FullWidthLayout>
    <Container white>
      <Row>
        <Col xs={12}>
          <SvgDownloader />
        </Col>
      </Row>
    </Container>
  </FullWidthLayout>
);
